import { useMemo } from "react";
import { Topbar } from "../ui/Topbar";
import { usePortfolio } from "../features/portfolio/usePortfolio";
import { useFxRates } from "../features/portfolio/useFxRates";
import { useSchedulesByPosition } from "../features/dashboard/useSchedulesByPosition";
import { KpiStrip } from "../features/dashboard/KpiStrip";
import { IssuersDonut } from "../features/dashboard/IssuersDonut";
import { MaturityBuckets } from "../features/dashboard/MaturityBuckets";
import { MonthlyForecast } from "../features/dashboard/MonthlyForecast";
import {
  groupByIssuer,
  groupByMaturityBucket,
  monthlyForecast,
} from "../features/dashboard/dashboardData";
import { useScrollRestore } from "../lib/useScrollRestore";

export default function Dashboard() {
  const portfolio = usePortfolio();
  const positions = portfolio.data?.positions ?? [];
  const secids = useMemo(() => positions.map((p) => p.position.secid), [positions]);
  const { byId: schedulesById } = useSchedulesByPosition(secids);
  const fx = useFxRates();
  const fxRates = fx.data ?? {};
  const scrollRef = useScrollRestore<HTMLDivElement>("dashboard");

  const issuers = useMemo(() => groupByIssuer(positions), [positions]);
  const buckets = useMemo(() => groupByMaturityBucket(positions), [positions]);
  const months = useMemo(
    () => monthlyForecast(positions, schedulesById, 12, fxRates),
    [positions, schedulesById, fxRates],
  );

  return (
    <>
      <Topbar title="Дашборд портфеля" />

      {portfolio.isError && (
        <div className="banner error">
          ошибка: {String(portfolio.error)}
        </div>
      )}

      <KpiStrip
        summary={portfolio.data?.summary}
        positions={portfolio.data?.positions}
      />

      <div ref={scrollRef} className="page-scroll">
        {portfolio.data && positions.length === 0 && (
          <div className="banner">
            нет открытых позиций — добавь первую на странице портфеля
          </div>
        )}

        {portfolio.data && positions.length > 0 && (
          <>
            <div className="dashboard-charts-grid">
              <IssuersDonut slices={issuers} />
              <MaturityBuckets buckets={buckets} />
            </div>

            <MonthlyForecast months={months} />
          </>
        )}
      </div>
    </>
  );
}
